import React from 'react'
import ReporteCamiones from '../ReporteCamiones'
import ReporteListosParaBruto from '../../components/ReporteListosParaBruto'

function ReporteCamionesListosParaBruto (props) {
  const { camListosParaBruto, titulo = null } = props

  return (
    <ReporteCamiones
      buttonName={titulo || 'Listos para bruto'}
      contenido={<ReporteListosParaBruto
        camListosParaBruto={camListosParaBruto}
      />
      }
    />
  )
}

export default ReporteCamionesListosParaBruto
